import * as React from "react";
import { FilterDisplayContext } from './FilterDisplayContext';

export default function FilterWrapper(props) {
  const {label, children, kind, attribute} = props;
  const { collapsible } = React.useContext(FilterDisplayContext);
  const classNames = ['filter-wrapper', `filter-wrapper--${kind}`];

  // Collapsible: a <details> the viewer can fold. Otherwise a plain always-open
  // section. Behaviour is chart-level (config.collapsibleFilters).
  if (collapsible) {
    return (
      <details className={classNames.join(' ')} data-attribute={attribute} data-kind={kind} open>
        <summary>
          <strong>{label}</strong>
          <div className="filter-wrapper__arrow"></div>
        </summary>
        <div className='filter-wrapper__content'>
          {children}
        </div>
      </details>
    );
  }

  return (
    <div className={classNames.join(' ')} data-attribute={attribute} data-kind={kind}>
      <div className='p-medium my-3'>
        <strong>{label}</strong>
      </div>
      <div className='filter-wrapper__content'>
        {children}
      </div>
    </div>
  );
}
